import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const PromotionLabel: React.FC<ISvgAtomProps> = ({ width = 100, height = 12 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="#BC2E2450" />
      <text x={10} y={height / 2} textAnchor="start" dominantBaseline="middle" fill="#666" fontSize={8}>
        Promotion label
      </text>
    </svg>
  );
};

export default PromotionLabel;
